import { LoadingButton } from '@mui/lab';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { useState } from 'react';
import Proptypes from 'prop-types';

import { api as stockApi } from '../../store/domains/stock';
import { useAutoCompleteState } from '../../hooks/useAutoCompleteState';
import Render from '../Render';
import { transferResponseHandler } from '../../utils/transferResponse';

const StartPackFormText = ({ handleClose, hubId, isTransfer }) => {
  const [mutation, { isLoading }] = stockApi.usePostAssignStartPackWithList();
  const [mutationTransfer, { isLoading: isLoadingTransfer }] = stockApi.usePostAssignStartPackWithListTransfer();

  const { data: posManagerOrganizations, isLoading: posManagerLoading } = stockApi.useGetPosManagerOrganizations(
    hubId,
    {
      skip: !hubId,
    }
  );

  const { data: posManagerPartners, isLoading: posManagerOrganizationsLoading } = stockApi.useGetOrganizations(null, {
    skip: !isTransfer,
  });

  const [partnerId, handleChange] = useAutoCompleteState();
  const [toPartner, handleChangeToPartner] = useAutoCompleteState();

  const [text, setText] = useState();
  function handleChangeText(event) {
    setText(event.target.value);
  }

  const onSubmit = () => {
    const identifiers = text?.split('\n');

    if (isTransfer) {
      const data = {
        identifiers,
        fromPartner: partnerId,
        toPartner,
      };
      mutationTransfer(data)
        .unwrap()
        .then(transferResponseHandler)
        .finally(() => {
          handleClose();
        });
      return;
    }

    const data = {
      body: { identifiers },
      partnerId,
    };
    mutation(data)
      .unwrap()
      .finally(() => {
        handleClose();
      });
  };
  if (posManagerLoading || isLoadingTransfer || posManagerOrganizationsLoading) {
    return <CircularProgress />;
  }
  return (
    <Box paddingTop={4}>
      <Autocomplete
        value={partnerId}
        onChange={handleChange}
        options={posManagerOrganizations || []}
        renderInput={(params) => <TextField {...params} label="Select Partner" />}
        fullWidth
      />
      <Render shouldRender={isTransfer}>
        <Autocomplete
          value={toPartner}
          onChange={handleChangeToPartner}
          options={posManagerPartners || []}
          renderInput={(params) => <TextField {...params} label="Select Partner to transfer" />}
          fullWidth
          sx={{ mt: 2 }}
        />
      </Render>
      <Box display="flex" alignItems="center" marginTop={3}>
        <TextField fullWidth label="Write..." multiline rows={4} value={text} onChange={(e) => handleChangeText(e)} />
      </Box>

      <LoadingButton
        loading={isLoading}
        disabled={isLoading || !text || !partnerId}
        onClick={onSubmit}
        sx={{ my: 2 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

StartPackFormText.propTypes = {
  handleClose: Proptypes.func,
  hubId: Proptypes.number,
  isTransfer: Proptypes.bool,
};
export default StartPackFormText;
